import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate, useLocation } from 'react-router-dom';
import FlagstoneTheme from '../config/flagstoneTheme';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import PDFDialog from '../base/dialogs/PDFDialog';
import PublicIcon from '@mui/icons-material/Public';
import { getAuth, signOut } from "firebase/auth";


export default function HeaderComponent(props) {

    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorLangEl, setAnchorLangEl] = useState(null);
    const [placement, setPlacement] = useState(null);
    const [helpFilesDialogOpen, setHelpFilesDialogOpen] = React.useState(false);
    const { pathname } = useLocation();

    const open = Boolean(anchorEl);
    const openLang = Boolean(anchorLangEl);
    const id = open ? 'simple-popper' : undefined;
    const idLang = openLang ? 'simple-popper-lang' : undefined;
    let username = props.user.username;
    const navigate = useNavigate();
    const auth = getAuth();

    const logOut = () => {

        signOut(auth).then((response) => {
            props.actions.logout();
            navigate('/login');
            props.actions.setLogin(false);
            props.actions.setUserid(null);

            // Sign-out successful.
        }).catch((error) => {
            console.log(error, 'error')
            // An error happened.
        });
    }

    const handleClick = (newPlacement) => (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        setPlacement(newPlacement);
    };

    const handleClickLanguage = (newPlacement) => (event) => {
        setAnchorLangEl(anchorLangEl ? null : event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCloseLang = () => {
        setAnchorLangEl(null);
    };

    const handleRedirect = (link) => {
        if (link === "/help") {
            setHelpFilesDialogOpen(true);
        }
    }

    const handleLanguageChange = (newlang) => {
        setAnchorLangEl(null);
    }

    const navigateToRegistrations = () => {
        navigate('/');
    }

    return (
        <div className={classes.headerComponent}>
            <button className={classes.smartTransform} onClick={() => navigateToRegistrations()}>
                <img className={classes.img} alt={process.env.PUBLIC_URL + '/img/Wasteware_ac_1b.png'} src={process.env.PUBLIC_URL + '/img/Wasteware_ac_1b.png'}></img>
            </button>
            <div className={classes.links}>
                <NavLink to="/" className={isActive =>
                    isActive.isActive || pathname === '/' ? classes.homeActiveLink : classes.homeLink
                }>
                    {"Registraties"}
                </NavLink>
                <NavLink to="/reports" className={isActive =>
                    isActive.isActive ? classes.mappingsActiveLink : classes.mappingsLink
                }>
                    {"Rapportage"}
                </NavLink>
                {/* <NavLink to="/transport" className={isActive =>
                    isActive.isActive ? classes.mappingsActiveLink : classes.mappingsLink
                }>
                    {"Ontvangen ritten"}
                </NavLink> */}
                <NavLink to="/files" className={isActive =>
                    isActive.isActive ? classes.mappingsActiveLink : classes.mappingsLink
                }>
                    {"Bestanden"}
                </NavLink>
                {/* <NavLink to="/transform" className={isActive =>
                    (isActive.isActive) ? classes.mappingsActiveLink : classes.mappingsLink
                }>
                    {"Converteer jouw excel"}
                </NavLink> */}



                {/* <NavLink to="/mappings" className={isActive =>
                    isActive.isActive ? classes.mappingsActiveLink : classes.mappingsLink
                }>
                    Mappings
                </NavLink> */}
                {/* <div className={classes.helpLink}  key="help" onClick={() => handleRedirect("/help")}>
                        {"Help"}
                    </div>
                <PDFDialog {...props} dialogOpen={helpFilesDialogOpen} closeDialog={() => setHelpFilesDialogOpen(false)}></PDFDialog> */}

            </div>
            {/* <button className={classes.language} aria-describedby={idLang} onClick={handleClickLanguage('bottom-end')}>
                <div className={classes.imgLogOut}>

                    <PublicIcon className={classes.downIcon}></PublicIcon>

                    <Menu id={idLang}
                        anchorEl={anchorLangEl}
                        open={Boolean(anchorLangEl)}
                        onClose={handleCloseLang}>
                        <MenuItem onClick={() => handleLanguageChange('nl')}>{t('Dutch')}</MenuItem>
                        <MenuItem onClick={() => handleLanguageChange('en')}>{t('English')}</MenuItem>
                        <MenuItem onClick={() => handleLanguageChange('fr')}>{t('French')}</MenuItem>
                    </Menu>
                </div>
            </button> */}
            <button className={classes.user} aria-describedby={id} onClick={handleClick('bottom-end')}>
                <div className={classes.imgLogOut}>
                    <ArrowDropDownIcon className={classes.downIcon}></ArrowDropDownIcon>
                    <Popper id={id} open={open} anchorEl={anchorEl} placement={placement} transition>
                        {({ TransitionProps }) => (
                            <Fade {...TransitionProps} timeout={500}>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <div className={classes.paper} onClick={() => logOut()}>{"Logout"} </div>
                                </ClickAwayListener>

                            </Fade>
                        )}
                    </Popper>

                </div>
                <div className={classes.hiUser}>
                    {"Hey"}, {username}
                </div>
                <div className={classes.imgUser}>
                    <PersonOutlineIcon className={classes.userIcon}></PersonOutlineIcon>
                </div>
            </button>
        </div>
    )
}


const useStyles = makeStyles({
    headerComponent: {
        height: "105px",
        width: "100%",
        backgroundColor: "white",
        boxShadow: "0px 3px 6px #00000029"
    },
    imgLogo: {
        float: "left"
    },

    links: {
        float: "left",
        paddingTop: "40px",
        marginLeft: "70px",
        width: "auto"
    },
    homeLink: {
        float: "left",
        fontFamily: "Lato, sans-serif",
        fontSize: "20px",
        color: "#616A6E",
        textDecoration: "none",
        '&:hover': {
            textDecoration: 'none !important',
            color: FlagstoneTheme.palette.primary.main,
        }
    },
    mappingsLink: {
        float: "left",
        marginLeft: "45px",
        fontFamily: "Lato, sans-serif",
        fontSize: "20px",
        color: "#616A6E",
        textDecoration: "none",
        '&:hover': {
            textDecoration: 'none !important',
            color: FlagstoneTheme.palette.primary.main,
        }
    },
    helpLink: {
        float: "left",
        marginLeft: "45px",
        fontFamily: "Lato, sans-serif",
        fontSize: "20px",
        color: "#616A6E",
        textDecoration: "none",
        cursor: "pointer",
        '&:hover': {
            textDecoration: 'none !important',
            color: FlagstoneTheme.palette.primary.main,
        }
    },
    homeActiveLink: {
        float: "left",
        fontFamily: "Lato, sans-serif",
        fontSize: "20px",
        color: FlagstoneTheme.palette.primary.main,
        fontWeight: "bold",
        textDecoration: "none",
        '&:hover': {
            textDecoration: 'none !important',
            color: FlagstoneTheme.palette.primary.main,
        }

    },
    mappingsActiveLink: {
        float: "left",
        marginLeft: "45px",
        fontFamily: "Lato, sans-serif",
        fontSize: "20px",
        color: FlagstoneTheme.palette.primary.main,
        fontWeight: "bold",
        textDecoration: "none",
        '&:hover': {
            textDecoration: 'none !important',
            color: FlagstoneTheme.palette.primary.main,
        }

    },
    imgUser: {
        float: "right",
        position: "relative",
        bottom: "3px"
    },
    imgLogOut: {
        float: "right",
        marginRight: "40px",

    },
    userIcon: {
        color: FlagstoneTheme.palette.primary.main,
    },
    downIcon: {
        color: FlagstoneTheme.palette.primary.main,
    },
    hiUser: {
        float: "right",
        fontFamily: "Lato, sans-serif",
        fontSize: "18px",
        color: "#616A6E",
        fontWeight: "bolder",
        marginLeft: "8px",
        marginRight: "8px"
    },
    user: {
        paddingTop: "40px",
        float: "right",
        border: "none",
        outline: "none",
        cursor: "pointer",
        backgroundColor: "white"
    },
    language: {
        paddingTop: "40px",
        float: "right",
        border: "none",
        outline: "none",
        cursor: "pointer",
        backgroundColor: "white"
    },
    logoutButton: {
        backgroundColor: "white",
        border: "0px",
        outline: "none",
        cursor: "pointer"
    },
    paper: {
        border: "1px solid",
        fontFamily: "Lato, sans-serif",
        fontSize: "16px",
        color: "#616A6E",
        padding: "20px",
        backgroundColor: "white",
        marginTop: "10px",
        marginRight: "50px",
        cursor: "pointer"
    },
    smart: {
        display: 'block',
        fontSize: "26px",
        fontFamily: "Campton-bold",
        color: "#4654FF",
        height: "20px",
        marginTop: "5px",
        textAlign: "left"
    },
    transform: {
        display: 'block',
        fontSize: "26px",
        fontFamily: "Campton-bold",
        color: "#000000",
        height: "20px"
    },
    smartTransform: {
        float: "left",
        marginTop: "15px",
        marginLeft: "20px",
        border: "none",
        outline: "none",
        cursor: "pointer",
        backgroundColor: "rgba(1,1,1,0)"
    },
    img: {
        width: "250px",
    },
});

